import { render, staticRenderFns } from "./SetupTopics.vue?vue&type=template&id=029f96c3&scoped=true"
import script from "./SetupTopics.vue?vue&type=script&lang=js"
export * from "./SetupTopics.vue?vue&type=script&lang=js"
import style0 from "./SetupTopics.vue?vue&type=style&index=0&id=029f96c3&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029f96c3",
  null
  
)

export default component.exports